import type { Response, AxiosResponse } from "../../types";
import { painelApi } from "../painelApi";

const PATH_V1_TASK = "/v1/task";

export async function executarRotina(): Promise<AxiosResponse<Response>> {
  return await painelApi.get(`${PATH_V1_TASK}/rotinadiaria`);
}
